export const CLIENT = "CLIENT";
export const CLIENT_SUCCESS = "CLIENT_SUCCESS";
export const CLIENT_ERROR = "CLIENT_ERROR";
export const CLIENT_CLEAR_DATA = "CLIENT_CLEAR_DATA";

export const CLIENT_ONE_BY_PROJECT = "CLIENT_ONE_BY_PROJECT";
export const CLIENT_ONE_BY_PROJECT_SUCCESS = "CLIENT_ONE_BY_PROJECT_SUCCESS";

export const CLIENT_ONE = "CLIENT_ONE";
export const CLIENT_ONE_SUCCESS = "CLIENT_ONE_SUCCESS";
export const CLIENT_ONE_ERROR = "CLIENT_ONE_ERROR";
export const CLIENT_ONE_CLEAR_DATA = "CLIENT_ONE_CLEAR_DATA";
